import { createApp } from 'vue'
import SubscribeApp from './SubscribeApp'

const appElement = document.getElementById('subscribe-app')

const app = createApp(SubscribeApp, {
    title: appElement.getAttribute('title'),
    placeholder: appElement.getAttribute('placeholder'),
    button: appElement.getAttribute('button')
})

app.mount('#subscribe-app')
